// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
if (!customElements.get('sp-world-menu')) {
  customElements.define('sp-world-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.animations = [];
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const container = this.querySelector('.sp-world-panels');
      const activate = tab => {
        const previous = tabs.findIndex(item => item.getAttribute('aria-selected') === 'true');
        const next = tabs.indexOf(tab);
        if (previous === next) return;
        const oldHeight = container?.getBoundingClientRect().height;
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
        });
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (container && panel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const direction = next > previous ? 1 : -1;
          const timing = { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' };
          this.animations = [
            container.animate([{ height: `${oldHeight}px` }, { height: `${container.getBoundingClientRect().height}px` }], timing),
            panel.animate([{ opacity: .15, transform: `translateX(${direction * 28}px)` }, { opacity: 1, transform: 'translateX(0)' }], timing)
          ];
        }
        const drawer = this.closest('header-drawer');
        if (drawer?.mainDetailsToggle.open) trapFocus(drawer.mainDetailsToggle, tab);
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => activate(tab), {signal:this.abort.signal});
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next]);
          tabs[next].focus();
        }, {signal:this.abort.signal});
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.animations?.forEach(animation => animation.cancel()); }
  });
}
